import { motion } from "framer-motion";

export default function Services() {
  return (
    <section id="work" className="py-24 md:py-32 bg-[#F6F6F2]" data-testid="services">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-mono2 text-xs tracking-[0.25em] text-[#005CEE] mb-4">03 / THE WORK</p>
            <h2 className="font-head font-extrabold tracking-tighter text-5xl md:text-7xl leading-none max-w-2xl">
              Rooms we've<br />made unforgettable.
            </h2>
          </div>
          <p className="text-[#8A8A85] max-w-xs leading-relaxed">
            Residential and commercial interiors across the region — every one finished to gallery standard.
          </p>
        </div>

        <div className="grid md:grid-cols-12 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="md:col-span-7 group relative overflow-hidden rounded-3xl h-[420px]"
          >
            <img
              src="https://images.pexels.com/photos/13141770/pexels-photo-13141770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Premium painted living room"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="absolute bottom-6 left-6 text-white translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <p className="font-head font-extrabold text-2xl">Modern Living Room</p>
              <p className="font-mono2 text-xs text-white/80">3-COAT MATTE · CEILINGS · TRIM</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="md:col-span-5 group relative overflow-hidden frame-arch h-[420px]"
          >
            <img
              src="https://images.unsplash.com/photo-1688372199140-cade7ae820fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxpbnRlcmlvciUyMHdhbGwlMjBwYWludGluZyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODMxMTkwODR8MA&ixlib=rb-4.1.0&q=85"
              alt="Painter at work"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mt-10">
          {[
            { k: "500+", v: "Rooms painted" },
            { k: "$1.80", v: "Per sq ft, always" },
            { k: "100%", v: "Satisfaction walk-through" },
          ].map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white rounded-2xl border border-[#E5E5DF] p-8"
            >
              <p className="font-mono2 text-4xl md:text-5xl text-[#005CEE]">{s.k}</p>
              <p className="mt-2 text-sm text-[#8A8A85]">{s.v}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
